import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'
import { updateKeys } from '../../functions/updateKeys'
const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const calendrierMaintenancesSlice = createSlice({
    name: 'calendrierMaintenances',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCalendrierMaintenances.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchCalendrierMaintenances.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchCalendrierMaintenances.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
          
    },
})

// Async thunk action to fetch data from the API
export const fetchCalendrierMaintenances = createAsyncThunk(
    'calendrierMaintenances/fetch',
    async (payload) => {
       


        try {
            const response = await BaseService.post(
                `/XML/main.eq.load/get_all_main`
            )
            const keyMap = {
                'date':'start',
                'nom':'title'
                        }
               
            return updateKeys(response.data.maintenance,keyMap)
        } catch (error) {
            throw new Error('Failed to fetch calendrierMaintenances')
        }
    }
)



export const editCalendrierMaintenance = createAsyncThunk('calendrierMaintenances/edit', async (data) => {    
    try {
     
        const response = await BaseService.post(`/XML/main.dm.send/update_date`, data)
        if (response.status === 200) {
            resetForm()
            setSubmitting(false)
            popNotification(edit?.success)
            navigate('/calendrierMaintenances')
        }
    } catch (err) {
        console.log({ err })
        
        popNotification(edit?.error)
    }
})



export const selectData = (state) => state.calendrierMaintenances.data
export const selectIsLoading = (state) => state.calendrierMaintenances.isLoading
export const selectError = (state) => state.calendrierMaintenances.error
export const selectIsDeleted = (state) => state.calendrierMaintenances.isDeleted
export const selectCurrentPage = (state) => state.calendrierMaintenances.currentPage

export default calendrierMaintenancesSlice.reducer
